/**
 * created by tian ruo jun
 融媒发布下网站管理页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";
import BaseComponent from "../../base/BaseComponent";

export default class Website extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Button type="primary" onClick={this.addStory}>写稿</Button>
            </div>
        )
    }

    addStory = () => {
        //获取网站流程的code
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.wblc", "activitiTreeRoot-xlc-wblc");
        const targetWindow = window.openEditById({configName:"webEditor",id:0, params:{activitiConfName}});
    }

}